import axios from 'axios';
import { adminMainUrl } from '../../../Config';

//unused final Quotation with Pagination List
export const getSalesBillingList = (token, user_id, page, impexp, airsea, billtype, queryString) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_SALES_BILLING_LIST_REQUEST",
        });

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/billing`;
        const queryParams = [];
        if (page) queryParams.push(`page=${page}`);
        // if (search_text) queryParams.push(`search=${search_text}`);
        if (queryParams.length > 0) apiUrl += `?${queryParams.join("&")}`;

        const extraBody = {};
        if (queryString) {
            const params = new URLSearchParams(queryString);

            params.forEach((value, key) => {
                if (key !== "page") {
                    extraBody[key] = value;
                }
            });
        }

        let body = {
            airsea: airsea,
            impexp: impexp,
            page: page ?? 1,
            ...extraBody

        };
        if (billtype == "customer") { body.billtype = billtype }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_SALES_BILLING_LIST_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                console.log("ERROR in getSalesBillingList function (redux):", err);
                dispatch({
                    type: "FIND_SALES_BILLING_LIST_FAILURE",
                    payload: err,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getSalesBillingList function:", error);
            dispatch({
                type: "FIND_SALES_BILLING_LIST_FAILURE",
                payload: error,
            });
        }
    };
};

//get job orders
export const getBillingJobOrder = (token, user_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_BILLING_JOB_ORDER_REQUEST",
        });

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/billing/job-order`;

        try {
            axios.get(apiUrl, config).then((res) => {
                dispatch({
                    type: "FIND_BILLING_JOB_ORDER_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                let errmsg = "Internal server error";
                if (err && err.response && err.response.data && err.response.data.msg) {
                    errmsg = err.response.data.msg
                }
                console.log("ERROR in getBillingJobOrder function (redux):", err, errmsg);
                dispatch({
                    type: "FIND_BILLING_JOB_ORDER_FAILURE",
                    payload: errmsg,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getBillingJobOrder function:", error);
            let errmsg = "Internal server error.";
            if (error && error.message) {
                errmsg = error.message
            }
            dispatch({
                type: "FIND_BILLING_JOB_ORDER_FAILURE",
                payload: errmsg,
            });
        }
    };
};

//view job order details
export const getBillingJobOrderDetails = (token, user_id, job_order_id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_BILLING_JOB_ORDER_DETAILS_REQUEST",
        });

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/billing/job-order/view`;

        let body = {
            job_order_id: job_order_id
        }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_BILLING_JOB_ORDER_DETAILS_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                let errmsg = "Internal server error";
                if (err && err.response && err.response.data && err.response.data.msg) {
                    errmsg = err.response.data.msg
                }
                console.log("ERROR in getBillingJobOrderDetails function (redux):", err, errmsg);
                dispatch({
                    type: "FIND_BILLING_JOB_ORDER_DETAILS_FAILURE",
                    payload: errmsg,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getBillingJobOrderDetails function:", error);
            let errmsg = "Internal server error.";
            if (error && error.message) {
                errmsg = error.message
            }
            dispatch({
                type: "FIND_BILLING_JOB_ORDER_DETAILS_FAILURE",
                payload: errmsg,
            });
        }
    };
};

//view billing details
export const getBillingDetails = (token, user_id, id) => {
    return async function (dispatch) {
        dispatch({
            type: "FIND_BILLING_DETAILS_REQUEST",
        });

        let config = {
            headers: {
                'auth-token': token,
                'user_id': user_id,
                'Content-Type': 'application/json',
            }
        };
        let apiUrl = `${adminMainUrl}/api/account/billing/view`;

        let body = {
            id: id
        }

        try {
            axios.post(apiUrl, body, config).then((res) => {
                dispatch({
                    type: "FIND_BILLING_DETAILS_SUCCESS",
                    payload: res?.data,
                });
            }).catch((err) => {
                let errmsg = "Internal server error";
                if (err && err.response && err.response.data && err.response.data.msg) {
                    errmsg = err.response.data.msg
                }
                console.log("ERROR in getBillingDetails function (redux):", err, errmsg);
                dispatch({
                    type: "FIND_BILLING_DETAILS_FAILURE",
                    payload: errmsg,
                });
            });
        } catch (error) {
            console.log("Unexpected error in getBillingDetails function:", error);
            let errmsg = "Internal server error.";
            if (error && error.message) {
                errmsg = error.message
            }
            dispatch({
                type: "FIND_BILLING_DETAILS_FAILURE",
                payload: errmsg,
            });
        }
    };
};
